import { Modal, ModalBody, ModalFooter, ModalHeader } from '@growtherapy/sprout-ui';

export function EarlyEndSessionModal({
  isOpen,
  isRestartLoading = false,
  onClose,
  onRestart,
  onComplete,
}: {
  isOpen: boolean;
  isRestartLoading?: boolean;
  onClose: () => void;
  onRestart: () => void;
  onComplete: () => void;
}) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} onOutsideClick={onClose}>
      <ModalHeader>End session early?</ModalHeader>
      <ModalBody>
        <ul className='list-disc pl-5 space-y-2'>
          <li>
            To troubleshoot audio or video issues, select <span className='font-medium'>“Restart session”</span>
          </li>
          <li>
            To end the session for everyone, select <span className='font-medium'>“End session”</span>
          </li>
        </ul>
      </ModalBody>
      <ModalFooter
        actions={[
          {
            key: 'restart',
            use: 'secondary',
            loading: isRestartLoading,
            onClick: onRestart,
            actionContent: 'Restart session',
          },
          {
            key: 'complete',
            use: 'destructive',
            onClick: onComplete,
            actionContent: 'End session',
          },
        ]}
      />
    </Modal>
  );
}
